(function($){

	// Обновление корзины после изменения кол-ва
	$(document).on('change', '.cart-table-item-counter input', function() {
		document.querySelector('button[name="update_cart"]').removeAttribute('disabled');
		document.querySelector('button[name="update_cart"]').click();
	});

})(jQuery);